import React from 'react';
import GridItem from './GridItem';

const AccordionPanel = props => {

    return (
        <div className="varinatPickerComponent-panel">
            <div className="row">
                <div className="col-md-8 col-md-push-2 text-center">
                    <h2 className="u-textBold20">{props.title}</h2>
                    <div className="u-textRegular18">{props.description}</div>
                </div>
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <div className="variantPickerComponent-products">
                        {
                            Object.keys(props.data).map(x => (
                                <GridItem data={props.data[x]} addToCart={props.addToCart} />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AccordionPanel;